export default __webpack_public_path__ + "static/media/group-7849.be8fb5f7.svg";